import { HubConnection } from '@microsoft/signalr';
import React, { useState, useEffect, useCallback } from 'react'
import { useLoginService } from '../../services/login.service';
import stylesLogin from './login.module.css';
import { browserName } from 'react-device-detect';
import Page from '../../components/layout/page.component';
import styles from '../../index.module.css'
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import SignalRHelper from '../../components/infra/signalrHelper.component';
import { useAuth } from '../../providers/auth.provider';
import logo from '../../assets/img/logo.png';

enum LoginPhase {
    BackendIinitializing,
    BackendReady,
    AwaitingTelegram
}

enum SignalRMethods {
    successLogin = 'successLogin',
    failedLogin = 'failedLogin'
}

export default function Login() {
    const [login, setLogin] = useState('');
    const [loginMessage, setLoginMessage] = useState('Inicializando... (Caso não responda em 1 minuto, atualize a página)');
    const [loginPhase, setLoginPhase] = useState(LoginPhase.BackendIinitializing);
    const [loginConnection, setLoginConnection] = useState<HubConnection>();
    const [promoCode, setPromoCode] = useState('');
    const [isRedeemingPromo, setIsRedeemingPromo] = useState(false);

    const { onLogin, onPromoLogin } = useAuth();
    const navigate = useNavigate();
    const service = useLoginService();

    useEffect(() => {
        if (loginConnection) {
            loginConnection.serverTimeoutInMilliseconds = 120 * 1000;

            loginConnection.start()
                .then(() => {
                    loginConnection.on(SignalRMethods.successLogin, async data => {
                        if (data) {
                            loginConnection.stop()
                                .then(() => onLogin(data.code))
                                .then(() => {
                                    toast('Login realizado!');
                                    navigate('/');
                                })
                                .catch(() => toast.error('Falha ao realizar o login!'))
                        }
                        else throw new Error('login failed.')
                    });

                    loginConnection.on(SignalRMethods.failedLogin, () => {
                        loginConnection.stop();
                        throw new Error('login failed.');
                    });
                })
                .catch(e => {
                    console.log('Connection failed: ', e);
                    setLoginPhase(LoginPhase.BackendIinitializing);
                    toast.error('Falha ao realizar o login!')
                });

            loginConnection.onclose(() => setLoginPhase(LoginPhase.BackendIinitializing));

            return () => {
                if (loginConnection)
                    loginConnection.stop();
            }
        }
    }, [loginConnection, onLogin, navigate])

    const doHealthCheck = useCallback(async () => {
        if (loginPhase !== LoginPhase.BackendIinitializing) return;

        const { data } = await service.healthCheck();
        if (data === 'Healthy') {
            setLoginPhase(LoginPhase.BackendReady);
        }
    }, [service, loginPhase])

    useEffect(() => {doHealthCheck();}, [doHealthCheck]);

    const doLogin = async (e: any) => {
        if (!login) {
            toast.warn('Informe o login');
            return;
        }

        const { data } = await service.doLogin({
            login
        });

        if (data) {
            //create connection
            setLoginPhase(LoginPhase.AwaitingTelegram);

            setLoginConnection(SignalRHelper.NewConnection(`loginHub?login=${login}&browser=${browserName}`));
            setLoginMessage('Aprove a entrada no Telegram...');
        }
        else {
            toast.error('Login inválido!');
        }
    }

    const doPromoLogin = async () => {
        if (isRedeemingPromo) return;

        const code = promoCode.trim();
        if (!code) {
            toast.warn('Informe o código promocional');
            return;
        }

        setIsRedeemingPromo(true);
        try {
            await onPromoLogin(code);
            toast('Login realizado!');
            navigate('/');
        }
        catch {
            toast.error('Código promocional inválido ou expirado!');
        }
        finally {
            setIsRedeemingPromo(false);
        }
    }

    return <Page width='narrow'>
        <div className={stylesLogin.card}>
            <img src={logo} alt='' className={stylesLogin.logo} />
            <h1 className={stylesLogin.title}>Entrar no Portal VIP</h1>
            <p className={stylesLogin.subtitle}>Use seu usuário do Telegram. A entrada é aprovada direto pelo bot.</p>
            <input
                name="txtsearch"
                type="text"
                autoComplete="username"
                aria-label="Usuário do Telegram"
                className={styles.urltext}
                placeholder="Digite seu usuário..."
                value={login}
                onChange={(e) => setLogin(e.target.value)}
                onKeyUp={(e) => { if (e.key === 'Enter' && loginPhase === LoginPhase.BackendReady) doLogin(e); }}
            />

            {loginPhase === LoginPhase.BackendReady && <div
                className={`${styles.button} ${stylesLogin.submit}`}
                role='button'
                tabIndex={0}
                onClick={doLogin}
            >
                Logar com Telegram
            </div>}
            {(loginPhase === LoginPhase.AwaitingTelegram || loginPhase === LoginPhase.BackendIinitializing) && <p className={stylesLogin.status}>{loginMessage}</p>}

            <div className={stylesLogin.divider}><span>ou</span></div>

            <p className={stylesLogin.subtitle}>Tem um código promocional? Use-o até a data de validade.</p>
            <input
                name="txtpromocode"
                type="text"
                autoComplete="one-time-code"
                autoCapitalize="characters"
                spellCheck={false}
                aria-label="Código promocional"
                className={`${styles.urltext} ${stylesLogin.promoCode}`}
                placeholder="Digite seu código..."
                value={promoCode}
                onChange={(e) => setPromoCode(e.target.value.toUpperCase())}
                onKeyUp={(e) => { if (e.key === 'Enter') doPromoLogin(); }}
            />
            <div
                className={`${styles.button} ${stylesLogin.submit}`}
                role='button'
                tabIndex={0}
                aria-disabled={isRedeemingPromo}
                onClick={doPromoLogin}
                onKeyUp={(e) => { if (e.key === 'Enter') doPromoLogin(); }}
            >
                {isRedeemingPromo ? 'Entrando...' : 'Entrar com código promocional'}
            </div>
        </div>
    </Page>
}